module.exports = __webpack_public_path__ + "img/phone-p.83e46fdd.svg";